import React from "react";
import { Route, Switch, Redirect } from "react-router";
import { MainContext } from "../DashboardContext/Context";
import AppliedJobs from "./AppliedJobs/AppliedJobs";
import "./dashboard-body.style.scss";
import Deactivate from "./Deactivate/Deactivate";
import JobDescription from "./JobDescription/JobDescription";
import JobListing from "./JobListing/JobListing";
import UserProfile from "./UserProfile/UserProfile";
export default function DashboardBody() {
  const context = React.useContext(MainContext);
  const { userDetails } = context;
  return (
    <div className="dashboard-body-main">
      <Switch>
        <Route path="/user/description/:jobId" component={JobDescription} />
        <Route path="/user/list/applied-jobs" component={AppliedJobs} />
        <Route
          path="/user/list/search"
          render={() => <JobListing type="search" />}
        />
        <Route path="/user/list/all" render={() => <JobListing type="all" />} />
        <Route
          path="/user/list/recommended-jobs"
          render={() => <JobListing type="recommended-jobs" />}
        />
        <Route
          path="/user/list/saved-jobs"
          render={() => <JobListing type="saved-jobs" />}
        />
        <Route
          path="/user/list/applied-jobs"
          render={() => <JobListing type="applied-jobs" />}
        />
        <Route path="/user/deactivate" component={Deactivate} />
        <Route path="/user/profile" component={UserProfile} />
        <Redirect to="/user/list/all" />
      </Switch>
    </div>
  );
}
